<template>
  <div class="layout">
    <sidebarNav class="sidebar"/>
    <mainContent  class="mainContent"/>
  </div>
</template>

<script>
import sidebarNav from "./component/sidebar-nav";
import mainContent from "./component/main-content";
export default {

  components: {
    sidebarNav,
    mainContent
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  height: 100vh; 
  width: 100vw;
  min-width: 1570px;

  .sidebar{
    min-width: 212px;
    width: 15%;
  }
  .mainContent{
    width: 85%;
  }
}
</style>
